/**
 * The payload of a JWT access token, decoded and NOT verified. For choosing between tokens and comparing what
 * a token names with an answer, never for deciding access: backends verify tokens and platform-api decides.
 * Null when the token is not a JWT with a JSON object payload.
 */
export function decodeTokenPayload(token) {
    const parts = token.split('.');
    if (parts.length !== 3 || !parts[1])
        return null;
    try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const binary = atob(base64 + '='.repeat((4 - (base64.length % 4)) % 4));
        const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
        const payload = JSON.parse(new TextDecoder().decode(bytes));
        return typeof payload === 'object' && payload !== null && !Array.isArray(payload)
            ? payload
            : null;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=token-claims.js.map